import { render } from "./SetCookiesView.vue?vue&type=template&id=46f6611d"
import script from "./SetCookiesView.vue?vue&type=script&lang=js"
export * from "./SetCookiesView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__